
<template>
  <v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
    <v-dialog v-model="permitted_dialog" max-width="400px">
      <v-card>
        <v-card-text>
          <div class="text-center">
            <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
            <p>{{message}}</p>
            <v-progress-circular
              :size="70"
              :width="2"
              :value="100"
              color="error"
              class="mb-4 mr-4"
            >
              <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
            </v-progress-circular>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
  <v-container v-else v-show="permitted != null" class="pt-0" fluid>
    <v-snackbar
      :value="showMessage()"
      multi-line
      color="#686868"
      top
      
    >
      {{message}}
    </v-snackbar>
    <v-card flat >
    <v-toolbar dense flat color="#2A353D">
      <v-toolbar-title class="white--text subtitle-1 font-weight-normal">{{heading}}</v-toolbar-title>
      <v-spacer/>
      <v-btn fab x-small outlined color="#81DBF6" class="mr-1" v-if="edit == true || create == true" @click="view = false; closeCreate(); closeEdit()"><v-icon>mdi-chevron-left</v-icon></v-btn>
      <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>

      <v-progress-linear
        :active="loading"
        :indeterminate="loading"
        absolute
        bottom
        color="#81DBF6"
      ></v-progress-linear>
    </v-toolbar>
    </v-card>

    <v-alert
      class="my-2"
      dense text
      color="#2A353D"
    >
      <v-row align="center" class="mx-2">
        <v-col class="py-0">
          <v-select
            filled rounded background-color="white" dense
            hide-details
            v-model="parameters.AccountID"
            :items="allClientAccounts"
            class="mx-1"
            @change="getValuation()"
            :item-text="item => item.tblclient.Forename + ` ` + item.tblclient.MajorName +` - ` + item.AccountNumber"
            item-value="AccountID"
            placeholder="----"
            label="Account"
          ></v-select>
        </v-col>
        <v-col class="py-0">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="parameters.effective_date"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="parameters.effective_date"
                class="mx-1"
                label="Effective Date"
                append-icon="mdi-calendar-month"
                readonly placeholder="--/--/--"
                hide-details
                dense filled rounded background-color="white" color="#2A353D"
                :rules="TextFieldRules"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker @change="getValuation()" color="#2A353D" v-model="parameters.effective_date" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn outlined small color="#2A353D" @click="menu = false">Cancel</v-btn>
            <v-btn outlined small color="#2A353D" @click="$refs.menu.save(parameters.effective_date)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </v-alert>

    <v-sheet class="mt-4 elevation-12">
      <v-toolbar color="white" dark dense flat>
        <v-spacer/>
        <v-btn @click="generatePDF()" outlined small color="#2A353D" v-on="on">
          PRINT<v-icon small>mdi-printer</v-icon>
        </v-btn>

        <template v-slot:extension>
          <v-tabs light color="#2A353D" v-model="tabs" fixed-tabs>
            <v-tabs-slider color="#2A353D"></v-tabs-slider>
            <v-tab v-if="summary != [] && summary != null && summary != ''">Summary</v-tab>
            <v-tab v-if="cash != [] && cash != null && cash != ''">Cash</v-tab>
            <v-tab v-if="unit_trust != [] && unit_trust != null && unit_trust != ''">Unit Trust</v-tab>
            <v-tab v-if="commodity != [] && commodity != null && commodity != ''">Commodities</v-tab>
            <v-tab v-if="m_market != [] && m_market != null && m_market != ''">Interest Bearing Investments</v-tab>
            <v-tab v-if="property != [] && property != null && property != ''">Property</v-tab>
            <v-tab v-if="equity != [] && equity != null && equity != ''">Public Equity</v-tab>
            <v-tab v-if="private_equity != [] && private_equity != null && private_equity != ''">Private Equity</v-tab>
            <v-tab v-if="dfb != [] && dfb != null && dfb != ''">Due from Broker</v-tab>
            <v-tab v-if="dtb != [] && dtb != null && dtb != ''">Due to Broker</v-tab>
            <v-tab v-if="equity_stl != [] && equity_stl != null && equity_stl != ''">Equity Settlements</v-tab>
          </v-tabs>
        </template>
      </v-toolbar>

      <v-tabs-items v-model="tabs">
        <v-tab-item v-if="summary != [] && summary != null && summary != ''">
          <v-data-table
            :fixed-header="true"
            :headers="summary_headers"
            :items="summary"
            :height="390"
            hide-default-footer
            disable-pagination
          >
          </v-data-table>
        </v-tab-item>
        <v-tab-item v-if="cash != [] && cash != null && cash != ''">
          <v-data-table
            :fixed-header="true"
            :headers="cash_headers"
            :items="cash"
            :height="390"
            hide-default-footer
            disable-pagination
          >
          </v-data-table>        
        </v-tab-item>
        <v-tab-item v-if="unit_trust != [] && unit_trust != null && unit_trust != ''">
          <v-data-table
            :fixed-header="true"
            :headers="unit_trust_headers"
            :items="unit_trust"
            :height="390"
            hide-default-footer
            disable-pagination
          >
          </v-data-table>        
        </v-tab-item>
        <v-tab-item v-if="commodity != [] && commodity != null && commodity != ''">
          <v-data-table
            :fixed-header="true"
            :headers="commodity_headers"
            :items="commodity"
            :height="390"
            hide-default-footer
            disable-pagination
          >
          </v-data-table>        
        </v-tab-item>
        <v-tab-item v-if="m_market != [] && m_market != null && m_market != ''">
          <v-data-table
            :fixed-header="true"
            :headers="m_market_headers"
            :items="m_market"
            :height="390"
            hide-default-footer
            disable-pagination
          >
          </v-data-table>        
        </v-tab-item>
        <v-tab-item v-if="property != [] && property != null && property != ''">
          <v-data-table
            :fixed-header="true"
            :headers="property_headers"
            :items="property"
            :height="390"
            hide-default-footer
            disable-pagination
          >
          </v-data-table>        
        </v-tab-item>
        <v-tab-item v-if="equity != [] && equity != null && equity != ''">
          <v-data-table
            :fixed-header="true"
            :headers="equity_headers"
            :items="equity"
            :height="390"
            hide-default-footer
            disable-pagination
          >
          </v-data-table>        
        </v-tab-item>
        <v-tab-item v-if="private_equity != [] && private_equity != null && private_equity != ''">
          <v-data-table
            :fixed-header="true"
            :headers="private_equity_headers"
            :items="private_equity"
            :height="390"
            hide-default-footer
            disable-pagination
          >
          </v-data-table>        
        </v-tab-item>
        <v-tab-item v-if="dfb != [] && dfb != null && dfb != ''">
          <v-data-table
            :fixed-header="true"
            :headers="dfb_headers"
            :items="dfb"
            :height="390"
            hide-default-footer
            disable-pagination
          >
          </v-data-table>        
        </v-tab-item>
        <v-tab-item v-if="dtb != [] && dtb != null && dtb != ''">
          <v-data-table
            :fixed-header="true"
            :headers="dtb_headers"
            :items="dtb"
            :height="390"
            hide-default-footer
            disable-pagination
          >
          </v-data-table>        
        </v-tab-item>
        <v-tab-item v-if="equity_stl != [] && equity_stl != null && equity_stl != ''">
          <v-data-table
            :fixed-header="true"
            :headers="equity_stl_headers"
            :items="equity_stl"
            :height="390"
            hide-default-footer
            disable-pagination
          >
          </v-data-table>        
        </v-tab-item>
      </v-tabs-items>
    </v-sheet>
  </v-container>
</template>

<script>
import reportsService from '../services/reports.service';
import UserService from '../services/user.service';
import {mapGetters} from "vuex";
import jsPDF from 'jspdf';
import 'jspdf-autotable'

export default {
  data () {
    return {
      parameters: {},
      summary: [],
      cash: [],
      equity: [],
      private_equity: [],
      dfb: [],
      dtb: [],
      unit_trust: [],
      commodity: [],
      m_market: [],
      property: [],
      data: [],
      equity_stl: [],
      search: '',
      message: '',
      menu: false,
      loading: false,
      permitted: null,
      tabs: null,
      permitted_dialog: true,
      heading: "Client Valuation",
      summary_headers: [
        {
          text: 'AssetClass',
          align: 'start',
          sortable: false,
          value: 'AssetClass'
        },
        { text: 'BookValue', value: 'BookValue', sortable: false},
        { text: 'MarketValue', value: 'MarketValue', sortable: false},
        { text: 'Book Value %', value: 'BV %', sortable: false },
        { text: 'Market Value %', value: 'MV %', sortable: false }
      ],
      cash_headers: [
        {
          text: 'Instrument',
          align: 'start',
          sortable: false,
          value: 'InstrumentType'
        },
        { text: 'Amount', value: 'Cost', sortable: false},
        { text: 'Percent', value: 'Percent', sortable: false}
      ],
      dfb_headers: [
        {
          text: 'EquityName',
          align: 'start',
          sortable: false,
          value: 'EquityName'
        },
        { text: 'Date', value: 'Date', sortable: false},
        { text: 'Quantity', value: 'Quantity', sortable: false},
        { text: 'UnitPrice', value: 'UnitPrice', sortable: false},
        { text: 'Value', value: 'Value', sortable: false}
      ],
      dtb_headers: [
        {
          text: 'EquityName',
          align: 'start',
          sortable: false,
          value: 'EquityName'
        },
        { text: 'Date', value: 'Date', sortable: false},
        { text: 'Quantity', value: 'Quantity', sortable: false},
        { text: 'UnitPrice', value: 'UnitPrice', sortable: false},
        { text: 'Value', value: 'Value', sortable: false}
      ],
      unit_trust_headers: [
        {
          text: 'ClientName',
          align: 'start',
          sortable: false,
          value: 'ClientName'
        },
        { text: 'UnitBalance', value: 'UnitBalance', sortable: false},
        { text: 'UnitPrice', value: 'UnitPrice', sortable: false},
        { text: 'BookValue', value: 'BookValue', sortable: false},
        { text: 'BookValuePerUnit', value: 'BookValuePerUnit', sortable: false},
        { text: 'MarketValue', value: 'MarketValue', sortable: false},
        { text: 'PortfolioValue', value: 'PortfolioValue', sortable: false}
      ],
      commodity_headers: [
        {
          text: 'Name',
          align: 'start',
          sortable: false,
          value: 'CommodityName'
        },
        { text: 'ClientHolding', value: 'ClientHolding', sortable: false},
        { text: 'BookPrice', value: 'BookPrice', sortable: false},
        { text: 'BookValue', value: 'BookValue', sortable: false},
        { text: 'MarketPrice', value: 'MarketPrice', sortable: false},
        { text: 'MarketValue', value: 'MarketValue', sortable: false}
      ],
      equity_headers: [
        {
          text: 'Counter',
          align: 'start',
          sortable: false,
          value: 'EquityName'
        },
        { text: 'Holding', value: 'ClientHolding', sortable: false},
        { text: 'BookPrice', value: 'BookPrice', sortable: false},
        { text: 'BookValue', value: 'BookValue', sortable: false},
        { text: 'MarketPrice', value: 'MarketPrice', sortable: false},
        { text: 'MarketValue', value: 'MarketValue', sortable: false},
        { text: '% Equity', value: '% Of Equity', sortable: false},
        { text: '% Market Value', value: '% Market Value', sortable: false},
        { text: 'Unrealised Gain/Loss', value: 'Unrealised G/L', sortable: false},
        { text: 'Unrealised Gain/Loss %', value: '% Unrealised G/L', sortable: false},
      ],
      private_equity_headers: [
        {
          text: 'Counter',
          align: 'start',
          sortable: false,
          value: 'EquityName'
        },
        { text: 'Holding', value: 'ClientHolding', sortable: false},
        { text: 'BookPrice', value: 'BookPrice', sortable: false},
        { text: 'BookValue', value: 'BookValue', sortable: false},
        { text: 'MarketPrice', value: 'MarketPrice', sortable: false},
        { text: 'MarketValue', value: 'MarketValue', sortable: false},
        { text: '% Equity', value: '% Of Equity', sortable: false},
        { text: '% Market Value', value: '% Market Value', sortable: false},
        { text: 'Unrealised Gain/Loss', value: 'Unrealised G/L', sortable: false},
        { text: 'Unrealised Gain/Loss %', value: '% Unrealised G/L', sortable: false},
      ],
      m_market_headers: [
        {
          text: 'Instrument',
          align: 'start',
          sortable: false,
          value: 'Instrument'
        },
        { text: 'CounterParty', value: 'CounterParty', sortable: false },
        { text: 'Duration', value: 'Duration', sortable: false},
        { text: 'Cost', value: 'Cost', sortable: false},
        { text: 'Rate', value: 'Rate', sortable: false},
        { text: 'NetInterest', value: 'NetInterest', sortable: false },
        { text: 'AccruedInterest', value: 'AccruedInterest', sortable: false},
        { text: 'MaturityValue', value: 'MaturityValue', sortable: false },
        { text: 'DaysRun', value: 'DaysRun', sortable: false},
        { text: 'DaysToGo', value: 'DaysToGo', sortable: false },
        { text: 'MarketValue', value: 'MarketValue', sortable: false },
        { text: '% Money Market', value: '% Money Market Value', sortable: false },
        { text: '% Market Value', value: '% Market Value', sortable: false },
      ],
      equity_stl_headers: [
        {
          text: 'DealType',
          align: 'start',
          sortable: false,
          value: 'DealType'
        },
        { text: 'PurchaseDate', value: 'PurchaseDate', sortable: false},
        { text: 'SettlementDate', value: 'SettlementDate', sortable: false},
        { text: 'ValueDate', value: 'ValueDate', sortable: false},
        { text: 'Counter', value: 'Counter', sortable: false},
        { text: 'Quantity', value: 'Quantity', sortable: false},
        { text: 'Price', value: 'Price', sortable: false},
        { text: 'Value', value: 'Value', sortable: false},
        { text: 'Status', value: 'Status', sortable: false},
      ],
      property_headers: [
        {
          text: 'Name',
          align: 'start',
          sortable: false,
          value: 'PropertyName'
        },
        { text: 'Holding', value: 'ClientHolding', sortable: false},
        { text: 'BookPrice', value: 'BookPrice', sortable: false},
        { text: 'BookValue', value: 'BookValue', sortable: false},
        { text: 'MarketPrice', value: 'MarketPrice', sortable: false},
        { text: 'MarketValue', value: 'MarketValue', sortable: false},
        { text: '% Property', value: '% Of Property', sortable: false},
        { text: '% Market Value', value: '% Of Market', sortable: false},
        { text: 'Gain/Loss', value: 'Gain/Loss Value', sortable: false},
        { text: 'Gain/Loss (%)', value: '% Gain/Loss', sortable: false},
      ]
    }
  },

  computed: {
    ...mapGetters([
      "currentImage",
      "identity",
      "allCountries",
      "allCities",
      "allClientAccounts",
      "allCurrencies"
    ]),

    currentUser() {
      return this.$store.state.auth.user;
    },
  },

  methods: {
    getValuation() {
      if(this.parameters.effective_date != null && this.parameters.AccountID != null){
        this.loading = true;
        reportsService.getClientValuation(this.parameters)
        .then(response => {
          this.data = response.data;
          this.equity = response.data.equity;
          this.private_equity = response.data.p_equity;
          this.cash = response.data.cash;
          this.dfb = response.data.dfb;
          this.dtb = response.data.dtb;
          this.unit_trust = response.data.unit_trust;
          this.commodity = response.data.commodity;
          this.summary = response.data.summary;
          this.equity_stl = response.data.equity_stl;
          this.m_market = response.data.m_market;
          this.property = response.data.property;
          this.loading = false
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.loading = false
        })
      }
    },
    generatePDF() {
      const summary_columns = [
        { title: 'AssetClass', dataKey: 'AssetClass' },
        { title: 'BookValue', dataKey: 'BookValue' },
        { title: 'MarketValue', dataKey: 'MarketValue' },
        { title: 'Book Value %', dataKey: 'BV %' },
        { title: 'Market Value %', dataKey: 'MV %' }
      ];

      const cash_columns = [
        { title: 'Instrument', dataKey: 'InstrumentType' },
        { title: 'Amount', dataKey: 'Cost' },
        { title: 'Percent', dataKey: 'Percent' }
      ];

      const dfb_columns = [
        { title: 'EquityName', dataKey: 'EquityName' },
        { title: 'Date', dataKey: 'Date' },
        { title: 'Quantity', dataKey: 'Quantity' },
        { title: 'UnitPrice', dataKey: 'UnitPrice' },
        { title: 'Value', dataKey: 'Value' }
      ];

      const dtb_columns = [
        { title: 'EquityName', dataKey: 'EquityName' },
        { title: 'Date', dataKey: 'Date' },
        { title: 'Quantity', dataKey: 'Quantity' },
        { title: 'UnitPrice', dataKey: 'UnitPrice' },
        { title: 'Value', dataKey: 'Value' }
      ];

      const unit_trust_columns = [
        { title: 'ClientName', dataKey: 'ClientName' },
        { title: 'UnitBalance', dataKey: 'UnitBalance' },
        { title: 'UnitPrice', dataKey: 'UnitPrice' },
        { title: 'BookValue', dataKey: 'BookValue' },
        { title: 'BookValuePerUnit', dataKey: 'BookValuePerUnit' },
        { title: 'MarketValue', dataKey: 'MarketValue' },
        { title: 'PortfolioValue', dataKey: 'PortfolioValue' }
      ];

      const commodity_columns = [
        { title: 'Name', dataKey: 'CommodityName' },
        { title: 'ClientHolding', dataKey: 'ClientHolding' },
        { title: 'BookPrice', dataKey: 'BookPrice' },
        { title: 'BookValue', dataKey: 'BookValue' },
        { title: 'MarketPrice', dataKey: 'MarketPrice' },
        { title: 'MarketValue', dataKey: 'MarketValue' }
      ];

      const equity_columns = [
        { title: 'Counter', dataKey: 'EquityName' },
        { title: 'Holding', dataKey: 'ClientHolding' },
        { title: 'BookPrice', dataKey: 'BookPrice' },
        { title: 'BookValue', dataKey: 'BookValue' },
        { title: 'MarketPrice', dataKey: 'MarketPrice' },
        { title: 'MarketValue', dataKey: 'MarketValue' },
        { title: '% Equity', dataKey: '% Of Equity' },
        { title: '% Market Value', dataKey: '% Market Value' },
        { title: 'Unrealised Gain/Loss', dataKey: 'Unrealised G/L' },
        { title: 'Unrealised Gain/Loss %', dataKey: '% Unrealised G/L' },
      ];

      const private_equity_columns = [
        { title: 'Counter', dataKey: 'EquityName' },
        { title: 'Holding', dataKey: 'ClientHolding' },
        { title: 'BookPrice', dataKey: 'BookPrice' },
        { title: 'BookValue', dataKey: 'BookValue' },
        { title: 'MarketPrice', dataKey: 'MarketPrice' },
        { title: 'MarketValue', dataKey: 'MarketValue' },
        { title: '% Equity', dataKey: '% Of Equity' },
        { title: '% Market Value', dataKey: '% Market Value' },
        { title: 'Unrealised Gain/Loss', dataKey: 'Unrealised G/L' },
        { title: 'Unrealised Gain/Loss %', dataKey: '% Unrealised G/L' },
      ];

      const m_market_columns = [
        { title: 'Instrument', dataKey: 'Instrument' },
        { title: 'CounterParty', dataKey: 'CounterParty' },
        { title: 'Duration', dataKey: 'Duration' },
        { title: 'Cost', dataKey: 'Cost' },
        { title: 'Rate', dataKey: 'Rate' },
        { title: 'NetInterest', dataKey: 'NetInterest' },
        { title: 'AccruedInterest', dataKey: 'AccruedInterest' },
        { title: 'MaturityValue', dataKey: 'MaturityValue' },
        { title: 'DaysRun', dataKey: 'DaysRun' },
        { title: 'DaysToGo', dataKey: 'DaysToGo' },
        { title: 'MarketValue', dataKey: 'MarketValue' },
        { title: '% Money Market', dataKey: '% Money Market Value' },
        { title: '% Market Value', dataKey: '% Market Value' },
      ];

      const equity_stl_columns =[
        { title: 'DealType', dataKey: 'DealType'},
        { title: 'PurchaseDate', dataKey: 'PurchaseDate' },
        { title: 'SettlementDate', dataKey: 'SettlementDate' },
        { title: 'ValueDate', dataKey: 'ValueDate' },
        { title: 'Counter', dataKey: 'Counter' },
        { title: 'Quantity', dataKey: 'Quantity' },
        { title: 'Price', dataKey: 'Price' },
        { title: 'Value', dataKey: 'Value' },
        { title: 'Status', dataKey: 'Status' },
      ]

      const property_columns = [
        { title: 'Name', dataKey: 'PropertyName' },
        { title: 'Holding', dataKey: 'ClientHolding' },
        { title: 'BookPrice', dataKey: 'BookPrice' },
        { title: 'BookValue', dataKey: 'BookValue' },
        { title: 'MarketPrice', dataKey: 'MarketPrice' },
        { title: 'MarketValue', dataKey: 'MarketValue' },
        { title: '% Property', dataKey: '% Of Property' },
        { title: '% Market Value', dataKey: '% Of Market' },
        { title: 'Gain/Loss', dataKey: 'Gain/Loss Value' },
        { title: 'Gain/Loss (%)', dataKey: '% Gain/Loss' }
      ];

      const addFooters = doc => {
        const pageCount = doc.internal.getNumberOfPages()

        for (var i = 1; i <= pageCount; i++) {
          var imgData = 'data:image/png;base64,'+ this.currentImage[0].data;

          doc.addImage(imgData, 'PNG', 0.5, 0.28, 1.55, 0.9);
          doc.setPage(i)
          // text is placed using x, y coordinates
          doc.setFontSize(10).text(this.identity[0].OrgName,  8.5, 0.4);
          doc.setFontSize(8).text(this.identity[0].Phadd1,  8.5, 0.55);
          doc.setFontSize(8).text(this.allCities.filter(a => a.CityID == this.identity[0].PhCity).map(a => a.City)[0],  8.5, 0.7);
          doc.setFontSize(8).text(this.allCountries.filter(a => a.CountryId == this.identity[0].PhCountry).map(a => a.CountryName)[0],  8.5, 0.85);
          doc.setFontSize(8).text('email: ' + this.identity[0].OrgMail,  8.5, 1.0);
          doc.setFontSize(8).text('cell: ' + this.identity[0].OrgNumber,  8.5, 1.15);
          // create a line under letterhead
          doc.setLineWidth(0.01).line(0.5, 1.3, 10.5, 1.3);
          doc.setFontSize(10).text(this.heading + ' as at ' + this.parameters.effective_date, 0.5, 1.55);
          doc.setFontSize(9).text(this.parameters.AccountID > 0? 'Client: ' + this.allClientAccounts.filter(a => a.AccountID == this.parameters.AccountID).map(a => a.tblclient.Forename) + ' ' + this.allClientAccounts.filter(a => a.AccountID == this.parameters.AccountID).map(a => a.tblclient.MajorName) + (this.allClientAccounts.filter(a => a.AccountID == this.parameters.AccountID).map(a => a.AccountDesc)[0]?.length > 0 ? ` - ${this.allClientAccounts.filter(a => a.AccountID == this.parameters.AccountID).map(a => a.AccountDesc)}` : '') : '', 0.5, 1.72);
          doc.setFontSize(9).text(this.parameters.AccountID > 0? 'Account: ' + this.allClientAccounts.filter(a => a.AccountID == this.parameters.AccountID).map(a => a.AccountNumber) + ` (${this.allCurrencies.filter(a => a.CurrencyID == this.allClientAccounts.filter(a => a.AccountID == this.parameters.AccountID).map(a => a.CurrencyID)).map(a => a.CurrencyCode)})`: '', 0.5, 1.9);
          // create a line under heading
          doc.setLineWidth(0.01).line(0.5, 2.4, 10.5, 2.4);
          doc.setLineWidth(0.01).line(0.5, 2.6, 10.5, 2.6);
          doc.setFontSize(6).text('Page ' + String(i) + ' of ' + String(pageCount), 4.3, 10.7, {
            align: 'center'
          })
        }
      }

      let doc = new jsPDF({
        orientation: "landscape",
        unit: "in",
        format: "letter"
      });

      doc.setFont('helvetica');
      doc.setFontSize(5);
      if(this.summary != null && this.summary != [] && this.summary != ''){
        doc.autoTable({
          columns: summary_columns,
          body: this.summary,
          margin: { left: 0.5, top: 2.4 },
          styles: {overflow: 'linebreak',
                  fontSize: 6},
          showHeader: 'everyPage',
          beforePageContent: function(data) {
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(11);
            doc.text("Summary", 0.5, data.settings.margin.top - 0.09);
          },
          theme: 'plain'
        });   
        
        doc.setLineWidth(0.01).line(0.5, doc.autoTableEndPosY() - 0.23, 10.5, doc.autoTableEndPosY() - 0.23);
        doc.setLineWidth(0.01).line(0.5, doc.autoTableEndPosY() - 0.03, 10.5, doc.autoTableEndPosY() - 0.03);
      }
      if(this.cash != null && this.cash != [] && this.cash != ''){
        doc.autoTable({
          startY: doc.autoTableEndPosY() + 0.5,
          columns: cash_columns,
          body: this.cash,
          margin: { left: 0.5, top: 2.2 },
          styles: {
            overflow: 'linebreak',
            fontSize: 6
          },
          showHeader: 'everyPage',
          beforePageContent: function() {
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(11);
            doc.text("Cash", 0.5, doc.autoTableEndPosY() + 0.4);
            doc.setLineWidth(0.01).line(0.5, doc.autoTableEndPosY() + 0.5, 10.5, doc.autoTableEndPosY() + 0.5);
            doc.setLineWidth(0.01).line(0.5, doc.autoTableEndPosY() + 0.7, 10.5, doc.autoTableEndPosY() + 0.7);
          },
          theme: 'plain'
        });  
        
        doc.setLineWidth(0.01).line(0.5, doc.autoTableEndPosY() - 0.23, 10.5, doc.autoTableEndPosY() - 0.23);
        doc.setLineWidth(0.01).line(0.5, doc.autoTableEndPosY() - 0.03, 10.5, doc.autoTableEndPosY() - 0.03);

      }
      if(this.unit_trust != null && this.unit_trust != [] && this.unit_trust != ''){
        doc.autoTable({
          startY: (doc.internal.pageSize.getHeight() - doc.autoTableEndPosY()) + doc.autoTableEndPosY(),
          columns: unit_trust_columns,
          body: this.unit_trust,
          margin: { left: 0.5, top: 2.2 },
          styles: {
            overflow: 'linebreak',
            fontSize: 6
          },
          showHeader: 'everyPage',
          beforePageContent: function(data) {
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(11);
            doc.text("Unit Trust", 0.5, data.settings.margin.top - 0.1);
          },
          theme: 'plain'
        });       
        
        doc.setLineWidth(0.01).line(0.5, doc.autoTableEndPosY() - 0.23, 10.5, doc.autoTableEndPosY() - 0.23);
        doc.setLineWidth(0.01).line(0.5, doc.autoTableEndPosY() - 0.03, 10.5, doc.autoTableEndPosY() - 0.03);

      }
      if(this.commodity != null && this.commodity != [] && this.commodity != ''){
        doc.autoTable({
          startY: (doc.internal.pageSize.getHeight() - doc.autoTableEndPosY()) + doc.autoTableEndPosY(),
          columns: commodity_columns,
          body: this.commodity,
          margin: { left: 0.5, top: 2.2 },
          styles: {
            overflow: 'linebreak',
            fontSize: 6
          },
          showHeader: 'everyPage',
          beforePageContent: function(data) {
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(11);
            doc.text("Commodities", 0.5, data.settings.margin.top - 0.1);
          },
          theme: 'plain'
        });   
        
        doc.setLineWidth(0.01).line(0.5, doc.autoTableEndPosY() - 0.23, 10.5, doc.autoTableEndPosY() - 0.23);
        doc.setLineWidth(0.01).line(0.5, doc.autoTableEndPosY() - 0.03, 10.5, doc.autoTableEndPosY() - 0.03);

      }
      if(this.m_market != null && this.m_market != [] && this.m_market != ''){
        doc.autoTable({
          startY: (doc.internal.pageSize.getHeight() - doc.autoTableEndPosY()) + doc.autoTableEndPosY(),
          columns: m_market_columns,
          body: this.m_market,
          margin: { left: 0.5, top: 2.2 },
          styles: {overflow: 'linebreak',
                  fontSize: 6},
          showHeader: 'everyPage',
          beforePageContent: function(data) {
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(11);
            doc.text("Interest Bearing Investments", 0.5, data.settings.margin.top - 0.1);
          },
          theme: 'plain'
        });     
        
        doc.setLineWidth(0.01).line(0.5, doc.autoTableEndPosY() - 0.23, 10.5, doc.autoTableEndPosY() - 0.23);
        doc.setLineWidth(0.01).line(0.5, doc.autoTableEndPosY() - 0.03, 10.5, doc.autoTableEndPosY() - 0.03);

      }
      if(this.property != null && this.property != [] && this.property != ''){
        doc.autoTable({
          startY: (doc.internal.pageSize.getHeight() - doc.autoTableEndPosY()) + doc.autoTableEndPosY(),
          columns: property_columns,
          body: this.property,
          margin: { left: 0.5, top: 2.2 },
          styles: {overflow: 'linebreak',
                  fontSize: 6},
          showHeader: 'everyPage',
          beforePageContent: function(data) {
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(11);
            doc.text("Properties", 0.5, data.settings.margin.top - 0.1);
          },
          theme: 'plain'
        });   
        
        doc.setLineWidth(0.01).line(0.5, doc.autoTableEndPosY() - 0.23, 10.5, doc.autoTableEndPosY() - 0.23);
        doc.setLineWidth(0.01).line(0.5, doc.autoTableEndPosY() - 0.03, 10.5, doc.autoTableEndPosY() - 0.03);

      }
      if(this.equity != null && this.equity != [] && this.equity != ''){
        doc.autoTable({
          startY: (doc.internal.pageSize.getHeight() - doc.autoTableEndPosY()) + doc.autoTableEndPosY(),
          columns: equity_columns,
          body: this.equity,
          margin: { left: 0.5, top: 2.2 },
          styles: {
            overflow: 'linebreak',
            fontSize: 6
          },
          showHeader: 'everyPage',
          beforePageContent: function(data) {
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(11);
            doc.text("Listed Equity", 0.5, data.settings.margin.top - 0.1);
          },
          theme: 'plain'
        });        

        doc.setLineWidth(0.01).line(0.5, doc.autoTableEndPosY() - 0.23, 10.5, doc.autoTableEndPosY() - 0.23);
        doc.setLineWidth(0.01).line(0.5, doc.autoTableEndPosY() - 0.03, 10.5, doc.autoTableEndPosY() - 0.03);

      }
      if(this.private_equity != null && this.private_equity != [] && this.private_equity != ''){
        doc.autoTable({
          startY: (doc.internal.pageSize.getHeight() - doc.autoTableEndPosY()) + doc.autoTableEndPosY(),
          columns: private_equity_columns,
          body: this.private_equity,
          margin: { left: 0.5, top: 2.2 },
          styles: {
            overflow: 'linebreak',
            fontSize: 6
          },
          showHeader: 'everyPage',
          beforePageContent: function(data) {
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(11);
            doc.text("Private Equity", 0.5, data.settings.margin.top - 0.1);
          },
          theme: 'plain'
        });        

        doc.setLineWidth(0.01).line(0.5, doc.autoTableEndPosY() - 0.23, 10.5, doc.autoTableEndPosY() - 0.23);
        doc.setLineWidth(0.01).line(0.5, doc.autoTableEndPosY() - 0.03, 10.5, doc.autoTableEndPosY() - 0.03);

      }
      if(this.dfb != null && this.dfb != [] && this.dfb != ''){
        doc.autoTable({
          startY: (doc.internal.pageSize.getHeight() - doc.autoTableEndPosY()) + doc.autoTableEndPosY(),
          columns: dfb_columns,
          body: this.dfb,
          margin: { left: 0.5, top: 2.2 },
          styles: {
            overflow: 'linebreak',
            fontSize: 6
          },
          showHeader: 'everyPage',
          beforePageContent: function(data) {
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(11);
            doc.text("Due from Broker", 0.5, data.settings.margin.top - 0.1);
          },
          theme: 'plain'
        });        

        doc.setLineWidth(0.01).line(0.5, doc.autoTableEndPosY() - 0.23, 10.5, doc.autoTableEndPosY() - 0.23);
        doc.setLineWidth(0.01).line(0.5, doc.autoTableEndPosY() - 0.03, 10.5, doc.autoTableEndPosY() - 0.03);

      }
      if(this.dtb != null && this.dtb != [] && this.dtb != ''){
        doc.autoTable({
          startY: (doc.internal.pageSize.getHeight() - doc.autoTableEndPosY()) + doc.autoTableEndPosY(),
          columns: dtb_columns,
          body: this.dtb,
          margin: { left: 0.5, top: 2.2 },
          styles: {
            overflow: 'linebreak',
            fontSize: 6
          },
          showHeader: 'everyPage',
          beforePageContent: function(data) {
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(11);
            doc.text("Due to Broker", 0.5, data.settings.margin.top - 0.1);
          },
          theme: 'plain'
        });    
        
        doc.setLineWidth(0.01).line(0.5, doc.autoTableEndPosY() - 0.23, 10.5, doc.autoTableEndPosY() - 0.23);
        doc.setLineWidth(0.01).line(0.5, doc.autoTableEndPosY() - 0.03, 10.5, doc.autoTableEndPosY() - 0.03);

      }
      if(this.equity_stl != null && this.equity_stl != [] && this.equity_stl != ''){
        doc.autoTable({
          startY: (doc.internal.pageSize.getHeight() - doc.autoTableEndPosY()) + doc.autoTableEndPosY(),
          columns: equity_stl_columns,
          body: this.equity_stl,
          margin: { left: 0.5, top: 2.2 },
          styles: {overflow: 'linebreak',
                  fontSize: 6},
          showHeader: 'everyPage',
          beforePageContent: function(data) {
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(11);
            doc.text("Equity Settlements", 0.5, data.settings.margin.top - 0.1);
          },
          theme: 'plain'
        });

        doc.setLineWidth(0.01).line(0.5, doc.autoTableEndPosY() - 0.23, 10.5, doc.autoTableEndPosY() - 0.23);
        doc.setLineWidth(0.01).line(0.5, doc.autoTableEndPosY() - 0.03, 10.5, doc.autoTableEndPosY() - 0.03);

      }

      addFooters(doc);
      doc.output('dataurlnewwindow');
    },
    getFiltered(current){
      this.CurrentSettlementReport = current;
    },
    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },
  },

  mounted () {
    UserService.isReports().then(
      () => {
        this.permitted = true;
        this.message = '';
      },
      error => {
        this.permitted = false;
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }
}
</script>

<style scoped>
.v-btn {
  outline: none
}
</style>